import { QueryResult, useQuery } from '@apollo/client'
import type { GetPublicCategoryQuery } from 'apollo-gql'
import GET_PUBLIC_CATEGORY from 'graphql/queries/getPublicCategoryQuery'
import { currentMarketIdVar } from 'graphql/reactive'

type UsePublicCategoryReturn = {
  category: GetPublicCategoryQuery['market']['category']
} & Pick<QueryResult, 'error' | 'loading'>

const usePublicCategory = (slug: string): UsePublicCategoryReturn => {
  const marketId = currentMarketIdVar()

  const { loading, error, data } = useQuery(GET_PUBLIC_CATEGORY, {
    variables: {
      slug,
      marketId,
    },
  })
  const category = data?.market?.category

  return { loading, error, category }
}

export default usePublicCategory
